/**
 * What a scorecard calls its total column.
 *
 * Two nines are an **Out** and an **In**, exactly as the paper card prints
 * them. A round or a course of ONE nine has neither: there is nothing to be out
 * of and nothing to come in from, so its column is the **Total** it actually
 * is. `RoundScorecard` got that right and `CourseScorecard` did not, which is
 * the whole reason this is one rule in one place rather than a line of ternary
 * in each table.
 *
 * It shares the RULE and nothing else. The two tables stay uncoupled on
 * purpose — see `CourseScorecard`'s own note — because a shared TABLE would
 * have to be designed around player rows before both exist in the wild.
 */
export function totalLabel(nines: number, index: number): string {
  if (nines === 1) return 'Total'
  return index === 0 ? 'Out' : 'In'
}
